<template>
  <div class="entry-info-person">
    <div class="title-info" v-if="project.unionMatchId">
       <div class="player-info">
        <img :src="imageView(player.avatar)" />
        <div>{{ player.trueName }}</div>
       </div>
       <div class="match-info flex-center">
        {{ project.matchGroupName }}
        <div class="status">
          <span v-if="team.isSubmit === 0">未提交</span>
          <span v-else-if="team.auditStatus === 0 || team.auditStatus === 1">待确认</span>
          <span v-else-if="team.auditStatus === 3">已锁定</span>
          <span v-else-if="team.auditStatus === 2">已确认</span>
          <span v-else-if="team.auditStatus === -1">已退回</span>
        </div>
       </div>
    </div>
    <div class="return" v-if="team.auditStatus == -1">
      <div class="return-title">审核建议:</div>
      <div class="content overflow-text-tow">{{ team.auditRemark }}</div>
    </div>
    <div class="tabs" v-if="tabs.length > 1">
      <van-tabs v-model="active" @change="changeTab">
        <van-tab v-for="tab in tabs" :key="tab.value" :title="tab.text"></van-tab>
      </van-tabs>
    </div>
    <div v-show="active === 0" :class="{ 'readonly-mode': isReadOnly }">
      <PlayerForm 
        ref="playerForm"
        :form.sync="player"
        :player-signup-fields="psfs"
        :jerseys-size-fields="project.jerseysSizeFields"
        :jerseys-size-accessory="project.jerseysSizeAccessory"
        :player-number-range="project.playerNumberRange"
        :cert-type-columns="certTypeColumns"
        :player-signup-fields-label="playerSignupFieldsLabel"
        :sport-type="project.sportType"
        :max-age="project.maxAge"
        :min-age="project.minAge"
        :qiniu-token="qiniuToken"
        :gender-limit="project.genderLimit"
        :custom-text-options="project.customTextOptions"
      />
    </div>
    <div v-show="activeValue === 'backgroundForm'" :class="{ 'readonly-mode': isReadOnly }">
      <BackgroundForm ref="backgroundForm" :qiniu-token="qiniuToken" @update:form="updateBackgroundForm" :form="background" />
    </div>
    <div v-show="activeValue === 'equipmentForm'" :class="{ 'readonly-mode': isReadOnly }">
      <EquipmentForm ref="equipmentForm" @update:form="updateEquipmentForm" :form="equipmentInfo" />
    </div>
    <div v-show="activeValue === 'mediaForm'" :class="{ 'readonly-mode': isReadOnly }">
      <MediaForm ref="mediaForm" @update:form="updateSocialMediaUsing" :form="socialMediaUsing" />
    </div>
    <div style="height: 120px;"></div>
    <div class="footer" v-if="showButton">
      <div class="left">
        <div class="update item" @click="goUpdatePlayer">
          <img src="@/assets/person-update-icon.png" />
          编辑信息
        </div>
        <div class="delete item" @click="cancelBMMatchTeam()">
          <img src="@/assets/person-delete-icon.png" />
          取消报名
        </div>
      </div>
      <div class="right">
        <div class="btn" v-if="team.isSubmit === 0 || team.auditStatus === -1" @click="updateBMMatchTeam()">提交</div>
      </div>
    </div>
  </div>
</template>

<script>
import { DateUtil, QNImageUtil } from "@/utils";
import Vue from 'vue'
import {
  Dialog, Toast, Tabs, Tab
} from 'vant'
import { getQiniuUploadToken } from "@/api/qiniu";
import {
  bangsaishiCreateTeamSignupOrder,
  getAreaTreeList,
  getBMMatchTeamSignup,
  checkBMMatchBeforeSubmit,
  submitBMMatchTeam,
  cancelBMMatchTeam
} from "@/api/match";
import { getPassport } from "@/libs/passport";
import { playerSignupFieldsLabel } from "@/config";
Vue.use(Dialog).use(Toast).use(Tabs).use(Tab)

import PlayerForm from '@/components/PlayerForm'
import BackgroundForm from '@/components/BackgroundForm'
import EquipmentForm from '@/components/EquipmentForm'
import MediaForm from '@/components/MediaForm'
export default {
  components: {
    PlayerForm,
    BackgroundForm,
    EquipmentForm,
    MediaForm
  },
  data() {
    return {
      teamId: '',
      team: {},
      qiniuToken: '',
      player: {},
      project: {},
      playerSignupFieldsLabel: playerSignupFieldsLabel,
      psfs: [],
      active: 0,
      activeValue: 'playerForm',
      tabs: [{ text: '个人信息', value: 'playerForm' }],
      background: {},
      equipmentInfo: {},
      socialMediaUsing: {},
      // 添加只读模式控制
      isReadOnly: true,
      certTypeColumns: [
        { value: 1, label: '身份证' },
        { value: 11, label: '学籍卡' },
        { value: 2, label: '护照' },
        { value: 3, label: '港澳通行证' },
        { value: 4, label: '台胞证' },
        { value: 5, label: '港澳台回乡证' }
      ],
      showButton: false,
    }
  },
  watch: {
    active: {
      handler(newVal) {
        this.changeTab(newVal)
      }
    },
    // 监听只读模式变化
    isReadOnly: {
      handler(newVal) {
        if (newVal) {
          // 延迟执行，确保DOM已渲染
          this.$nextTick(() => {
            this.setupReadOnlyMode()
          })
        }
      },
      immediate: false
    }
  },
  mounted() {
    getPassport().then(res => {
      if (res) {
        this.unionMatchId = this.$route.query.unionMatchId
        this.projectId = this.$route.query.matchId
        this.teamId = this.$route.query.teamId
        this.getQiniuUploadToken()
        this.getAreaTreeList()
      }
    })
  },
  methods: {
    goUpdatePlayer() {
      this.$router.push(`/entry-page/entry-info-person?unionMatchId=${this.unionMatchId}&matchId=${this.projectId}&teamId=${this.teamId}`)
    },
    imageView(img) {
      if (!img) return ''
      return QNImageUtil.imageView(img)
    },
    cancelBMMatchTeam() {
      if ((this.project.isOpenCharge === 1 && this.project.feeMethod === 1 && this.project.isChargeCount > 0) || (this.project.isOpenCharge === 1 && (this.project.feeMethod === 2 || this.project.feeMethod === 3) && (this.project.orderStatus === 1 || this.project.orderStatus === 2))) {
        Dialog.alert({
          title: '取消失败',
          message: '已有队员支付报名费用，取消报名请联系组委会',
        })
        return
      }
      Dialog.confirm({
        title: '是否取消报名',
        message: '取消后，数据将丢失',
      }).then(() => {
        const params = {
          matchId: this.projectId,
          teamId: this.teamId
        }
        cancelBMMatchTeam(params).then(res => {
          if (res) {
            Toast.success('取消成功')
            this.$router.back()
          }
        })
      })
    },
    updateBMMatchTeam() {
      if (this.project.isOpenCharge === 1 && (this.project.feeMethod === 2 || this.project.feeMethod === 3) && this.project.orderStatus !== 1 && this.project.orderStatus !== 2) {
        const params = {
          teamId: this.teamId,
          matchId:this.projectId
        }
        checkBMMatchBeforeSubmit(params).then(res => {
          if (res) {
            Dialog.confirm({
              title: '尚未支付',
              message: '尚未支付，请前往支付费用',
            }).then(() => {
              const params = {
                matchId:this.projectId,
                teamId: this.teamId
              }
              bangsaishiCreateTeamSignupOrder(params).then(res => {
                if (res) {
                  this.$router.push(`/entry-page/payment?orderId=${res.data.orderId}&unionMatchId=${this.unionMatchId}&category=0&matchId=${this.projectId}&teamId=${this.teamId}`)
                }
              })
            })
          }
        })
      } else {
        checkBMMatchBeforeSubmit({
          teamId: this.teamId,
          matchId:this.projectId
        }).then(res => {
          if (res) {
            const params = {
              teamId: this.teamId,
              matchId:this.projectId
            }
            submitBMMatchTeam(params).then(res => {
              if (res) {
                Toast('提交成功')
                this.$router.back()
              }
            })
          }
        })
      }
    },
    changeTab(value) {
      this.activeValue = this.tabs[value].value
    },
    updateBackgroundForm(form) {
      this.background = form
    },
    updateEquipmentForm(form) {
      this.equipmentInfo = form
    },
    updateSocialMediaUsing(form) {
      this.socialMediaUsing = form
    },
    getAreaTreeList() {
      getAreaTreeList().then(res => {
        if (res) {
          const { data } = res
          this.options = JSON.parse(data.list.list.replaceAll("'", '"')) || []
          this.getBMMatchTeamSignup()
        }
      })
    },
    getAreaInfo(areaId, options, a) {
      if (!areaId) return ''
      for (let i = 0; i < options.length; i++) {
        if (options[i].id === areaId) {
          a.push(options[i].name)
          return true
        } else if (options[i].kids) {
          const b = this.getAreaInfo(areaId, options[i].kids, a)
          if (b) {
            a.push(options[i].name)
            return true
          }
        }
      }
      return false
    },
    getBMMatchTeamSignup() {
      const params = {
        matchId: this.projectId
      }
      if (this.teamId) {
        params.teamId = this.teamId
      }
      getBMMatchTeamSignup(params).then(res => {
        if (res) {
          const data = res.data || {}

          if (data.team) {
            this.showButton = (data.team.auditStatus != 2 && (data.team.isSubmit === 0 || data.team.auditStatus === -1))
            // 判断是否为只读模式：已提交且非退回状态，或者已确认状态
          } else {
            this.showButton = true
          }
          if (data.match.playerSignupFieldsLabel) {
            this.playerSignupFieldsLabel = {
              ...this.playerSignupFieldsLabel,
              ...data.match.playerSignupFieldsLabel,
            }
          }
          const project = data.match
          const psfs = project.playerSignupFields && project.playerSignupFields.split('|') || []
          this.psfs = psfs 
          if (psfs.includes('background')) {
            this.tabs.push({text: '足球背景', value: 'backgroundForm'})
          }
          if (psfs.includes('equipmentInfo')) {
            this.tabs.push({text: '装备信息', value: 'equipmentForm'})
          }
          if (psfs.includes('socialMediaUsing')) {
            this.tabs.push({text: '社交媒体使用', value: 'mediaForm'})
          }
          this.project = data.match
          this.team = data.team || {}
          const players = data.players || []
          if (players.length > 0) {
            const player = players[0]
            player.bmBirthdayValue = player.bmBirthday && this.getFormatDate(player.bmBirthday) || ''
            player.avatarList = player.avatar && [{ url: QNImageUtil.imageView(player.avatar), isImage: true }] || []
            player.IDCardPhotoAList = player.IDCardPhotoA && [{ url: QNImageUtil.imageView(player.IDCardPhotoA), isImage: true, hash: player.IDCardPhotoA }] || []
            player.IDCardPhotoBList = player.IDCardPhotoB && [{ url: QNImageUtil.imageView(player.IDCardPhotoB), isImage: true, hash: player.IDCardPhotoB }] || []

            player.certTypeValue = player.certType && this.certTypeColumns.find(i => i.value === player.certType)?.label || '身份证'
            if (player.certTypeValue === '身份证') {
              player.certType = 1
            }
            if (player.qualificationFile && player.qualificationFile.length > 0) {
              const a = player.qualificationFile.split(',') || []
              player.qualificationFileList = []
              a.forEach(item => {
                player.qualificationFileList.push({ url: QNImageUtil.imageView(item), isImage: true, hash: item })
              })
            } else {
              player.qualificationFileList = []
            }
            if (player.insureFile && player.insureFile.length > 0) {
              const a = player.insureFile.split(',') || []
              player.insureFileList = []
              a.forEach(item => {
                player.insureFileList.push({ url: QNImageUtil.imageView(item), isImage: true, hash: item })
              })
            } else {
              player.insureFileList = []
            }
            const a = []
            this.getAreaInfo(player.domicileAreaId, this.options, a)
            a.reverse()
            player.domicileAreaName = a.join('/')
            this.background = player.background || {}
            this.equipmentInfo = player.equipmentInfo || {}
            this.socialMediaUsing = player.socialMediaUsing || {}
            this.player = player
          }
        }
      })
    },
    getQiniuUploadToken() {
      getQiniuUploadToken({}).then(res => {
        this.qiniuToken = res.data.token
      })
    },
    getFormatDate(date) {
      if (!date) return ''
      return DateUtil.parseDateTime(date, '{y}-{m}-{d}')
    },
    setupReadOnlyMode() {
      // 只在只读模式下才添加事件阻止
      if (!this.isReadOnly) {
        return;
      }
      
      // 阻止所有表单相关的点击事件
      const formComponents = [
        this.$refs.playerForm,
        this.$refs.backgroundForm,
        this.$refs.equipmentForm,
        this.$refs.mediaForm
      ];

      formComponents.forEach(component => {
        if (component && component.$el) {
          // 阻止表单组件的点击事件
          component.$el.addEventListener('click', this.preventFormClick, true);
          // 阻止表单组件的子元素的点击事件
          component.$el.addEventListener('mousedown', this.preventFormClick, true);
          component.$el.addEventListener('mouseup', this.preventFormClick, true);
          component.$el.addEventListener('mousemove', this.preventFormClick, true);
          component.$el.addEventListener('mouseleave', this.preventFormClick, true);
          component.$el.addEventListener('touchstart', this.preventFormClick, true);
          component.$el.addEventListener('touchend', this.preventFormClick, true);
          component.$el.addEventListener('touchmove', this.preventFormClick, true);
          component.$el.addEventListener('touchcancel', this.preventFormClick, true);

          // 阻止表单组件的子元素的点击事件
          component.$el.querySelectorAll('*').forEach(el => {
            el.addEventListener('click', this.preventFormClick, true);
            el.addEventListener('mousedown', this.preventFormClick, true);
            el.addEventListener('mouseup', this.preventFormClick, true);
            el.addEventListener('mousemove', this.preventFormClick, true);
            el.addEventListener('mouseleave', this.preventFormClick, true);
            el.addEventListener('touchstart', this.preventFormClick, true);
            el.addEventListener('touchend', this.preventFormClick, true);
            el.addEventListener('touchmove', this.preventFormClick, true);
            el.addEventListener('touchcancel', this.preventFormClick, true);
          });
        }
      });

      // 阻止所有上传器的点击事件
      this.$el.querySelectorAll('.van-uploader').forEach(uploader => {
        uploader.addEventListener('click', this.preventUploaderClick, true);
        uploader.addEventListener('mousedown', this.preventUploaderClick, true);
        uploader.addEventListener('mouseup', this.preventUploaderClick, true);
        uploader.addEventListener('mousemove', this.preventUploaderClick, true);
        uploader.addEventListener('mouseleave', this.preventUploaderClick, true);
        uploader.addEventListener('touchstart', this.preventUploaderClick, true);
        uploader.addEventListener('touchend', this.preventUploaderClick, true);
        uploader.addEventListener('touchmove', this.preventUploaderClick, true);
        uploader.addEventListener('touchcancel', this.preventUploaderClick, true);

        // 阻止上传器的子元素的点击事件
        uploader.querySelectorAll('*').forEach(el => {
          el.addEventListener('click', this.preventUploaderClick, true);
          el.addEventListener('mousedown', this.preventUploaderClick, true);
          el.addEventListener('mouseup', this.preventUploaderClick, true);
          el.addEventListener('mousemove', this.preventUploaderClick, true);
          el.addEventListener('mouseleave', this.preventUploaderClick, true);
          el.addEventListener('touchstart', this.preventUploaderClick, true);
          el.addEventListener('touchend', this.preventUploaderClick, true);
          el.addEventListener('touchmove', this.preventUploaderClick, true);
          el.addEventListener('touchcancel', this.preventUploaderClick, true);
        });
      });

      // 阻止所有复选框的点击事件
      this.$el.querySelectorAll('.van-checkbox').forEach(checkbox => {
        checkbox.addEventListener('click', this.preventCheckboxClick, true);
        checkbox.addEventListener('mousedown', this.preventCheckboxClick, true);
        checkbox.addEventListener('mouseup', this.preventCheckboxClick, true);
        checkbox.addEventListener('mousemove', this.preventCheckboxClick, true);
        checkbox.addEventListener('mouseleave', this.preventCheckboxClick, true);
        checkbox.addEventListener('touchstart', this.preventCheckboxClick, true);
        checkbox.addEventListener('touchend', this.preventCheckboxClick, true);
        checkbox.addEventListener('touchmove', this.preventCheckboxClick, true);
        checkbox.addEventListener('touchcancel', this.preventCheckboxClick, true);

        // 阻止复选框的子元素的点击事件
        checkbox.querySelectorAll('*').forEach(el => {
          el.addEventListener('click', this.preventCheckboxClick, true);
          el.addEventListener('mousedown', this.preventCheckboxClick, true);
          el.addEventListener('mouseup', this.preventCheckboxClick, true);
          el.addEventListener('mousemove', this.preventCheckboxClick, true);
          el.addEventListener('mouseleave', this.preventCheckboxClick, true);
          el.addEventListener('touchstart', this.preventCheckboxClick, true);
          el.addEventListener('touchend', this.preventCheckboxClick, true);
          el.addEventListener('touchmove', this.preventCheckboxClick, true);
          el.addEventListener('touchcancel', this.preventCheckboxClick, true);
        });
      });

      // 阻止所有单元格的点击事件
      this.$el.querySelectorAll('.van-cell').forEach(cell => {
        cell.addEventListener('click', this.preventCellClick, true);
        cell.addEventListener('mousedown', this.preventCellClick, true);
        cell.addEventListener('mouseup', this.preventCellClick, true);
        cell.addEventListener('mousemove', this.preventCellClick, true);
        cell.addEventListener('mouseleave', this.preventCellClick, true);
        cell.addEventListener('touchstart', this.preventCellClick, true);
        cell.addEventListener('touchend', this.preventCellClick, true);
        cell.addEventListener('touchmove', this.preventCellClick, true);
        cell.addEventListener('touchcancel', this.preventCellClick, true);

        // 阻止单元格的子元素的点击事件
        cell.querySelectorAll('*').forEach(el => {
          el.addEventListener('click', this.preventCellClick, true);
          el.addEventListener('mousedown', this.preventCellClick, true);
          el.addEventListener('mouseup', this.preventCellClick, true);
          el.addEventListener('mousemove', this.preventCellClick, true);
          el.addEventListener('mouseleave', this.preventCellClick, true);
          el.addEventListener('touchstart', this.preventCellClick, true);
          el.addEventListener('touchend', this.preventCellClick, true);
          el.addEventListener('touchmove', this.preventCellClick, true);
          el.addEventListener('touchcancel', this.preventCellClick, true);
        });
      });

      // 阻止所有文本域的输入
      this.$el.querySelectorAll('.van-field__control--textarea textarea').forEach(textarea => {
        textarea.addEventListener('input', this.preventTextareaInput, true);
        textarea.addEventListener('keydown', this.preventTextareaInput, true);
        textarea.addEventListener('keypress', this.preventTextareaInput, true);
        textarea.addEventListener('keyup', this.preventTextareaInput, true);
        textarea.addEventListener('change', this.preventTextareaInput, true);
        textarea.addEventListener('blur', this.preventTextareaInput, true);
        textarea.addEventListener('focus', this.preventTextareaInput, true);
      });

      // 阻止所有按钮的点击事件
      this.$el.querySelectorAll('.van-button').forEach(button => {
        button.addEventListener('click', this.preventButtonClick, true);
        button.addEventListener('mousedown', this.preventButtonClick, true);
        button.addEventListener('mouseup', this.preventButtonClick, true);
        button.addEventListener('mousemove', this.preventButtonClick, true);
        button.addEventListener('mouseleave', this.preventButtonClick, true);
        button.addEventListener('touchstart', this.preventButtonClick, true);
        button.addEventListener('touchend', this.preventButtonClick, true);
        button.addEventListener('touchmove', this.preventButtonClick, true);
        button.addEventListener('touchcancel', this.preventButtonClick, true);
      });

      // 阻止所有标签页的切换
      this.$el.querySelectorAll('.van-tabs__nav').forEach(nav => {
        nav.addEventListener('click', this.preventTabClick, true);
        nav.addEventListener('mousedown', this.preventTabClick, true);
        nav.addEventListener('mouseup', this.preventTabClick, true);
        nav.addEventListener('mousemove', this.preventTabClick, true);
        nav.addEventListener('mouseleave', this.preventTabClick, true);
        nav.addEventListener('touchstart', this.preventTabClick, true);
        nav.addEventListener('touchend', this.preventTabClick, true);
        nav.addEventListener('touchmove', this.preventTabClick, true);
        nav.addEventListener('touchcancel', this.preventTabClick, true);
      });

      // 阻止所有标签页内容的点击事件
      this.$el.querySelectorAll('.van-tab__pane').forEach(pane => {
        pane.addEventListener('click', this.preventTabPaneClick, true);
        pane.addEventListener('mousedown', this.preventTabPaneClick, true);
        pane.addEventListener('mouseup', this.preventTabPaneClick, true);
        pane.addEventListener('mousemove', this.preventTabPaneClick, true);
        pane.addEventListener('mouseleave', this.preventTabPaneClick, true);
        pane.addEventListener('touchstart', this.preventTabPaneClick, true);
        pane.addEventListener('touchend', this.preventTabPaneClick, true);
        pane.addEventListener('touchmove', this.preventTabPaneClick, true);
        pane.addEventListener('touchcancel', this.preventTabPaneClick, true);
      });
    },
    preventFormClick(event) {
      event.stopPropagation();
    },
    preventUploaderClick(event) {
      event.stopPropagation();
    },
    preventCheckboxClick(event) {
      event.stopPropagation();
    },
    preventCellClick(event) {
      event.stopPropagation();
    },
    preventTextareaInput(event) {
      event.preventDefault();
    },
    preventButtonClick(event) {
      event.stopPropagation();
    },
    preventTabClick(event) {
      event.stopPropagation();
    },
    preventTabPaneClick(event) {
      event.stopPropagation();
    }
  }
}
</script>

<style lang="scss" scoped>
.entry-info-person {
  background-color: #EEEEEE;
  min-height: 100vh;
   .title-info {
    background-color: #fff;
    height: 86px;
    border-bottom: 10px solid #EEEEEE;
    .player-info{
      display: flex;
      align-items: center;
      height: 52px;
      padding-left: 18px;
      border-bottom: 1px solid #EEEEEE;
      img{
        height: 30px;
        width: 30px;
        border-radius: 50%;
        margin-right: 8px;
      }
    }
    .match-info{
      font-size: 12px;
      font-weight: 500;
      color: #999999;
      padding: 0 20px;
      height: 34px;
      .status{
        color: #30D55B;
      }
    }
  }
  .return{
    margin: 0 auto;
    background-color: #fff;
    width: 350px;
    height: 86px;
    border-radius: 5px;
    margin-bottom: 10px;
    .return-title{
      font-size: 13px;
      font-weight: bold;
      color: #333333;
      padding: 12px;
    }
    .content{
      padding: 0 12px;
      font-size: 13px;
      color: #3D3D3D;
    }
  }

  .team-info {
    padding: 12px;
    background-color: #F8F8F8;
    border-radius: 4px;

    .name {
      font-size: 16px;
      line-height: 30px;
      color: #333333;
    }

    .group {
      font-size: 14px;
      line-height: 30px;
      color: #8d8d8d;
    }

    .player-num {
      font-size: 14px;
      line-height: 30px;
      color: #333333;
    }
  }

  .title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 15px;
    color: #333333;
    padding: 25px 0 13px 0;
    // margin: 0 16px;
    border-bottom: 0.5px #EEEEEE solid;

    .icon {
      width: 2px;
      height: 12px;
      background-color: #7CCD19;
      margin-right: 6px;
    }
  }

  .bottom {
    position: fixed;
    bottom: 0;
    width: 100vw;
    padding: 14px 12px 12px 12px;
    box-sizing: border-box;
    background-color: #FFFFFF;
  }
  .footer{
    position: fixed;
    bottom: 0;
    width: 100vw;
    background-color: #FFFFFF;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px 34px 12px;
    .left{
      display: flex;
      .item{
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 12px;
        font-weight: 500;
        color: #73767A;
        margin-right: 18px;
        img{
          width: 27px;
          height: 27px;
          margin-bottom: 6px;
        }
      }
      .delete{
        color: #C45656;
      }
    }
    .right{
      .btn{
        width: 117px;
        height: 45px;
        border-radius: 69px;
        background: #509DEA;
        font-size: 15px;
        font-weight: 500;
        color: #fff;
        text-align: center;
        line-height: 45px;
      }
    }
  }
}
.readonly-mode {
    // 禁用所有表单组件的点击事件
    ::v-deep .van-field {
      pointer-events: none;
      
      &.van-field--clickable {
        pointer-events: none;
      }
      
      .van-field__control {
        pointer-events: none;
      }
    }
    
    // 禁用选择器
    ::v-deep .van-popup {
      pointer-events: none;
    }
    
    // 禁用上传器
    ::v-deep .van-uploader {
      pointer-events: none;
      
      .upload-placeholder {
        pointer-events: none;
        opacity: 0.6;
      }
    }
    
    // 禁用复选框
    ::v-deep .van-checkbox {
      pointer-events: none;
    }
    
    // 禁用单元格点击
    ::v-deep .van-cell {
      pointer-events: none;
      
      &.van-cell--clickable {
        pointer-events: none;
      }
    }
    
    // 禁用文本域输入
    ::v-deep .van-field__control--textarea textarea {
      pointer-events: none;
      background-color: #f5f5f5;
    }
    
    // 禁用所有按钮
    ::v-deep .van-button {
      pointer-events: none;
      opacity: 0.6;
    }
    
    // 禁用标签页切换
    ::v-deep .van-tabs__nav {
      pointer-events: none;
    }
    
    // 禁用标签页内容
    ::v-deep .van-tab__pane {
      pointer-events: none;
    }
  }
.agreement-top {
  .agreement-title {
    background-color: #fff;
    padding: 12px 12px 0 12px;
    text-align: center;
    font-weight: 600;
    font-size: 24px;
    margin-bottom: 4px;
  }

  .hint {
    text-align: center;
    font-size: 16px;
    color: #8C8C8C;
  }
}

.notice {
  .notice-title {
    text-align: center;
    font-size: 16px;
    padding: 12px 0;
    // border-bottom: 1px solid #f3f3f3;
  }

  .info {
    padding: 12px;
    white-space: pre-wrap;
  }

  .close {
    text-align: center;
    color: #576B95;
    // border-top: 1px solid #f3f3f3;
    padding: 12px 0;
  }

  .disabled {
    color: #999 !important;
  }
}

#agreement {
  padding: 0 24px 12px 24px;

  .wscnph {
    width: 100%;
  }
}

::v-deep .van-tabs__line{
  background-color: #1989FA !important;
}

::v-deep .player-form .title{
  background-color: #F5F5F5;
  font-size: 16px;
  font-weight: 600;
  color: #323233;
}
</style>
